import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	externalLinksAddLinkButton: {
		id: 'servicedesk-external-links.links.external-links-add-link-button',
		defaultMessage: 'Add link',
		description: 'Add link button text in external link page header',
	},
	externalLinksPageHeaderHeading: {
		id: 'servicedesk-external-links.links.external-links-page-header-heading',
		defaultMessage: 'External resources',
		description: 'Header text for external link page header',
	},
	externalLinksPageHeaderDescription: {
		id: 'servicedesk-external-links.links.external-links-page-header-description',
		defaultMessage:
			'Share helpful external resources as links on your portal. These links can be added to topics in your help center and will also show up in your help center search. View these links on your portal.',
		description: 'description text for external link page header',
	},
	externalLinksReorderingPageHeaderDescription: {
		id: 'servicedesk-external-links.links.external-links-reordering-page-header-description',
		defaultMessage:
			'Share helpful external resources as links on your portal. Add up to {limit, plural, one {# link} other {# links}} and drag and drop to reorder them. These links can be added to topics in your help center and will also show up in your help center search. <a>View these links on your portal.</a>',
		description: 'description text for external link page header when reordering is enabled',
	},
	externalLinksDeleteSuccessFlagTitle: {
		id: 'servicedesk-external-links.links.external-links-delete-success-flag-title',
		defaultMessage: 'Link removed',
		description: 'title text for external link delete success flag',
	},
	externalLinksDeleteSuccessFlagDescription: {
		id: 'servicedesk-external-links.links.external-links-delete-success-flag-description',
		defaultMessage: 'The link ‘{linkTitle}’ will no longer show up in your portal or help center.',
		description: 'description text for external link delete success flag',
	},
	externalLinksDeleteFailureTitle: {
		id: 'servicedesk-external-links.links.external-links-delete-failure-title',
		defaultMessage: 'We couldn’t remove this link',
		description: 'title text for external link delete failure flag',
	},
	externalLinksDeleteFailureDescription: {
		id: 'servicedesk-external-links.links.external-links-delete-failure-description',
		defaultMessage: 'Try again in some time.',
		description: 'description text for external link delete failure flag',
	},
	externalLinksMaxLimitReached: {
		id: 'servicedesk-external-links.links.external-links-max-limit-reached',
		defaultMessage: 'You’ve already added {limit, number} links. Remove a link to add another one.',
		description: 'description text for external links max limit reached',
	},
	externalLinksReorderDragIndicatorNonfinal: {
		id: 'servicedesk-external-links.links.external-links-reorder-drag-indicator-nonfinal',
		defaultMessage: 'Use arrow keys to reorder group',
		description: 'Aria label for the drag handler',
	},
	externalLinksReorderFailureTitle: {
		id: 'servicedesk-external-links.links.external-links-reorder-failure-title',
		defaultMessage: "We couldn't move that link",
		description: 'title text for external link reorder failure flag',
	},
	externalLinksReorderFailureDescription: {
		id: 'servicedesk-external-links.links.external-links-reorder-failure-description',
		defaultMessage: 'Try reordering it again in some time.',
		description: 'description text for external link reorder failure flag',
	},
});
